import {createSelector} from 'reselect';

const getApp = state => state.app;

export const selecetApptype = createSelector([getApp], app => app);
